import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {registerRoute} from 'workbox-routing';
import {CacheFirst} from 'workbox-strategies';
import 'semantic-ui-css/semantic.min.css'
import ShopContext from './ShopContext'


ReactDOM.render(
  <React.StrictMode>
    <ShopContext>
      <App />
    </ShopContext>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
serviceWorker.register();

registerRoute(
  ({request}) => request.destination === '/config.js',
  new CacheFirst()
);
